import { take, fork, cancel } from "redux-saga/effects";
import rootSaga from "./rootSaga";
import { SagaMiddleware } from "redux-saga";

const sagas: any[] = [rootSaga];

export const CANCEL_SAGAS_HMR = "CANCEL_SAGAS_HMR";

function createAbortableSaga(saga: () => Generator): () => Generator {
  if (process.env.NODE_ENV === "development") {
    return function* main(): Generator {
      const sagaTask: any = yield fork(saga);

      yield take(CANCEL_SAGAS_HMR);
      yield cancel(sagaTask);
    };
  } else {
    return saga;
  }
}

const SagaManager = {
  startSagas(sagaMiddleware: SagaMiddleware): void {
    sagas.map(createAbortableSaga).forEach((saga) => sagaMiddleware.run(saga));
  },

  cancelSagas(store: { dispatch: (action: { type: string }) => void }): void {
    store.dispatch({
      type: CANCEL_SAGAS_HMR,
    });
  },
};

export default SagaManager;
